import { useEffect } from 'react'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'
import { getMasterToken, onMasterLogout, clearMasterLogout } from '@/services/masterService'

export function MasterAuthGuard() {
  const navigate = useNavigate()
  const token = getMasterToken()

  useEffect(() => {
    onMasterLogout(() => navigate('/master/login', { replace: true }))
    return () => clearMasterLogout()
  }, [navigate])

  if (!token) return <Navigate to="/master/login" replace />
  return <Outlet />
}
